export default function CTA() {
  return (
    <section id="quote" className="relative w-full h-[500px] md:h-[600px] lg:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20modern%20global%20logistics%20hub%20at%20sunset%20with%20warm%20golden%20light%20washing%20over%20the%20scene%2C%20sleek%20cargo%20aircraft%20on%20tarmac%2C%20organized%20shipping%20containers%2C%20clean%20architectural%20lines%2C%20atmospheric%20haze%2C%20premium%20cinematic%20quality%2C%20warm%20amber%20and%20bronze%20sky%20tones%2C%20professional%20corporate%20photography&width=1800&height=900&seq=cta-bg-2026-v1&orientation=landscape"
          alt="Global logistics operations at sunset"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6 md:px-10">
        <h2 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white tracking-wider uppercase leading-tight mb-6 md:mb-8">
          Secure Your<br />Shipment
        </h2>
        <p className="text-white/80 text-sm md:text-lg max-w-lg mx-auto mb-8 md:mb-10 leading-relaxed">
          Request a confidential consultation and receive a tailored transport plan<br className="hidden md:block" />
          within four business hours.
        </p>
        <a
          href="#contact"
          className="group inline-flex items-center gap-0 rounded-full bg-foreground-950 hover:bg-foreground-900 transition-colors duration-300 cursor-pointer"
        >
          <span className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-500 flex-shrink-0">
            <i className="ri-send-plane-fill text-white text-lg md:text-xl"></i>
          </span>
          <span className="px-4 md:px-6 text-white font-semibold text-sm md:text-base tracking-wide uppercase whitespace-nowrap">
            Request a Quote
          </span>
          <span className="pr-5 md:pr-6">
            <i className="ri-arrow-right-up-line text-white text-base md:text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300 inline-block"></i>
          </span>
        </a>
      </div>
    </section>
  );
}